module.exports = {
  "title": "settings",
  "sub_text": "step up, set up!",
  "content_source": "Content Source",
  "paperflite":"Paperflite",
  "tabs": {
    "profile": "Profile",
    "notification": "Notification",
    "account": {
      "title": "Account",
      "account_management": "Account Management",
      "user_management": "User Management",
      "viewer_settings": "Viewer Settings",
      "hub_settings": "Hub Settings",
      "custom_fields": "Custom Fields",
      "privacy_policy_control": "Privacy Policy Control",
      "payment_history": "Payment History"
    },
    "stream_access_management": "Stream Access Management",
    "distribution_lists": "Distribution lists",
    "content_sources": "Content Sources",
    "integrations": "Integrations",
    "templates": {
      "title": "Templates",
      "email": "Email Templates",
      "nda": "NDA Templates"
    }
  },
  "profile": {
    "toast": {
      "success": "Profile updated successfully",
      "failure": {
        "heading": "Oops!",
        "description": "File size can't be greater than 2MB."
      }
    },
    "form": {
      "first_name": "First name",
      "last_name": "Last name",
      "title": "Title",
      "email": "Email",
      "work_phone": "Work phone",
      "mobile": "Mobile",
      "edit_profile": "Edit profile <br /> picture",
      "error_messages": {
        "valid_name": "Enter a valid name"
      }
    },
    "change_password": {
      "title": "Change password",
      "description": "Update your account password. Always set a strong password, which helps to prevent unauthorized access to your account.",
      "old_password": "Old password",
      "new_password": "New password",
      "re_enter_password": "Re-enter new password",
      "error_messages": {
        "invalid_password": "Please provide valid password",
        "characters": "Password should be 8 or more characters",
        "new_password_not_same": "Passwords provided don't match. Please re-enter the passwords",
        "same_password": "Password cannot be same as current password or previous two passwords"
      }
    },
    "email_signature": {
      "title": "Email Signature",
      "description": "Insert your custom signature here. This is a default feature in all outgoing emails or new email templates."
    }
  },
  "notification": {
    "title": "Notifications Center",
    "daily_digest": {
      "email": {
        "title": "Email Daily Digest",
        "description": "Receive a daily digest communication with a summary of activities over email"
      },
      "stream": {
        "title": "Stream Daily Digest",
        "description": "Stay on top of all updates in the Streams you follow.",
      }
    },
    'weekly_digest': {  
      "stream": {
        "title": "Stream Weekly Digest",
        "description": "Receive a weekly digest email with a summary of all updates in the streams you follow.",
      }
    },
    "transactional_notifications": {
      "title": "Transactional Notifications",
      "description": "Setup transactional notification triggers for browser based push notification and/or emails",
      "transaction_trigger": {
        "title": "Transaction trigger",
        "email_opened": "Email Opened",
        "link_clicked": "Link Clicked",
        "asset_viewed": "Asset Viewed",
        "asset_download": "Asset Download",
        "collection_viewed": "Collection Viewed",
        "content_reshared": "Content Reshared",
        "lead_captured": "Lead Captured"
      },
      "communication_channel": {
        "title": "Communication channel",
        "push_notification": "Push Notification",
        "email": "Email"
      }
    }
  },
  "account": {
    "account_management": {
      "tabs": {
        "account_settings": {
          "title": "Account Settings",
          "form": {
            "company_name": "Company name",
            "company_url": "Company Url",
            "fav_icon": "Fav Icon",
            "actions": {
              "edit_fav_icon": "Edit Fav Icon",
              "description": "196 * 196 px preferred size"
            }
          }
        },
        "collection_settings": {
          "title": "Collection Settings",
          "actions": {
            "edit_background": "Edit Background",
            "show_shared_by": "Show shared by",
            "enable_live_collection": "Enable live collection"
          },
          "default_experience": {
            "title": "Default Experience",
            "description": "Choose the default experience your recipients will see when you share content.",
            "metro": {
              "title": "Metro",
              "description": "Present your assets in a vertical tile wall, complete with a customizable cover page."
            },
            "carousel": {
              "title": "Carousel",
              "description": "Display your assets in an engaging carousel format that scrolls horizontally."
            },
            "bento":{
              "title": "Bento",
              "description": "A flexible wall to showcase your assets with unlimited possibilities for thumbnails and layouts."
            }
          }
        },
        "share_settings": {
          "title": "Share Settings",
          "download": {
            "title": "Download",
            "description": "Indicate whether to enable download for each share",
            "note": "*This applies to PPTs, Docs, Google Slides and Google Docs.",
            "options": {
              "editable": "Editable",
              "read_only": "Read Only"
            }
          },
          "reshare": {
            "title": "Reshare",
            "description": "Indicate whether to enable reshare for each share"
          },
          "gating": {
            "title": "Gating",
            "description": "Indicate whether to enable gating for each share",
            "validate_work_email": "Validate work email"
          }
        },
        "content_settings":{
          "title": "Asset Settings",
        },
        "get_started": {
          "title": "Get Started",
          "description": "Toggle the bars to the right to help your team get started with Paperflite.",
          "cards": {
            "my_hub": {
              "title": "My Hub",
              "description": "Enable content curation and distribution to your teams.",
              "sliders": {
                "title": "my hub",
                "off": "Clicking on the 'Confirm' button below will turn My Hub off. Turn it on to curate or distribute content within your organization.",
                "on": "Clicking on the 'Confirm' button below will turn My Hub on. It is designed to enable content curation and content distribution to your teams. We recommend you to turn this feature on when your organization has a high volume of content and or number of users."
              }
            },
            "global_contacts": {
              "title": "Global Contacts",
              "description": "Share consolidated list of contacts with all users across your organization.",
              "sliders": {
                "title": "global contacts",
                "off": "Turning this feature OFF will remove global contacts from Rolodex. You can turn this feature ON if you choose to provide access later.",
                "on": "Turn this feature ON if you'd like to share the consolidated list of contacts with all users across your organization. You can turn this OFF if you choose to restrict access later."
              }
            }
          }
        }
      }
    },
    "user_management": {
      "title": "User Management",
      "active_users": "Active Users",
      "actions": {
        "invite_user": "Invite a new user",
        "create_new_group": "Create new group",
        "manage_roles": "Manage roles"
      },
      "invite_user": {
        "email": "Enter email here to invite",
        "error_message": "Enter a valid email id",
        "role": {
          "title": "Select user role",
          "placeholder": "Choose an user role",
          "create_new_role": "Create New User Role",
          "starter_role": "Assign a starter seat to the user"

        },
        "group_name": {
          "title": "Select group name",
          "placeholder": "Choose a user group"
        }, 
        "actions": {
        "send_invite": "Send Invite",
        },
        "toast": {
          "success": "User {email} invited successfully"
        }, 
        "headers": {
          "first_name": "First name",
          "last_name": "Last name",
          "email": "Email",
          "joined_date": "Joined Date",
          "role": "Role",
          "status": "Status",
          "invited_date": "Invited Date",
          "name": "Name",
          "created_date": "Created Date",
          "total_users": "Total Users",
        }
      },
      "search": {
        "placeholder": "Search the users or user groups or invitations here"
      },
      "filters": {
        "title": "Filters",
        "all": "All",
        "users": "Users",
        "user_group": "User group",
        "invitation": "Invitation"
      },
      "card": {
        "invite_sent_on": "Invite sent on",
        "actions": {
          "add_users": "Add users",
          "activate": "Activate",
          "deactivate": "Deactivate",
          "resend_invite": "Resend Invite"
        },
        "toast": {
          "update": "User account {status} successfully",
          "resend_invite": "User invitation re-sent successfully",
          "delete": "User invitation deleted successfully"
        },
        "filters": {
          "all": "All"
        }
      },
      "create_new_group": {
        "title": "User Group Management",
        "placeholder": "Search groups",
        "group_name_placeholder": "Provide user group name",
        "actions": {
          "create_new_group": "Create new group",
          "add_users": "add users"
        },
        "permission": {
          "title": "Permissions",
          "administrator": "Administrator",
          "create_stream": "Create stream",
        },
        "add_contact": {
          "title": "add contact",
          "empty_message": {
            "title": "No search results?",
            "sub_text": "Add to your user list."
          }
        },
        "headers": {
          "first_name": "First Name",
          "last_name": "Last Name",
          "email": "Email",
          "role": "Role",
        },
        "delete": {
          "title": "deleting",
          "confirmation": "Are you sure you would like to delete the selected user group?"
        },
        "empty_message": "No visibility yet! This space is reserved for users",
        "error_message": "Please provide a valid name",
        "toast": {
          "group_created": "User group created successfully",
          "update": "User group {name} updated successfully"
        }
      },
      "manage_roles": {
        "title": "Manage Roles",
        "create_role": "Create Role",
        "search_placeholder": "search roles",
        "edit_role": "Edit Role",
        "role_name": "Role name",
        "error_message": "Please provide a valid name",
        "toast": {
          "created": "User Role {name} created successfully",
          "updated": "User Role {name} updated successfully"
        },
        "permissions": {
          "title": "Permissions",
          "hub": {
            "title": "Hub",
            "access": {
              "title": "Access",
              "sub_text": "Permmission to access the hub"
            },
            "create": {
              "title": "Create",
              "sub_text": "Permission to create a stream"
            },
            "edit": {
              "title": "Edit",
              "sub_text": "Permission to edit hub layout"
            }
          },
          "collection": {
            "title": "Collection",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access collections"
            },
            "create": {
              "title": "Create",
              "sub_text": "Permission to create a collection"
            },
            "collaborate": {
              "title": "Collaborate",
              "sub_text": "Permission to collaborate a collection"
            }
          },
          "conversations": {
            "title": "conversations",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access conversations"
            }
          },
          "engage": {
            "title": "Engage",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access the 'Engage' module and interact with recipients."
            },
            "access_all_recipients": {
              "title": "Access all recipients",
              "sub_text": "Permission to view interactions with all recipients of your Organisation."
            },
            "view_only": {
              "title": "View only",
              "sub_text": "View only access to prior interactions with the users' direct recipients."
            },
            "block_recipients": {
              "title": "Block recipients",
              "sub_text": "Ability to block select recipients from interacting with anyone in your Organization."
            }
          },
          "contacts": {
            "title": "Contacts",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access contacts"
            },
            "create": {
              "title": "Create",
              "sub_text": "Permission to create a contact"
            }
          },
          "reports": {
            "title": "Reports",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access reports"
            },
            "download": {
              "title": "Download",
              "sub_text": "Permission to download reports"
            },
            "restricted": {
              "title": "Restricted",
              "sub_text": "Restrict to access reports only of user groups the user is part of"
            }
          },
          "share": {
            "title": "Share",
            "accees": {
              "title": "Access",
              "sub_text": "Permission to access share"
            }
          },
          "asset": {
            "title": "Asset",
            "download": {
              "title": "Download",
              "sub_text": "Permission to download"
            }
          },
          "search": {
            "title": "Access",
            "access": {
              "title": "Access",
              "sub_text": "Permission to access search"
            }
          },
          "settings_management": {
            "title": "Settings Management",
            "user_management": {
              "title": "User Management",
              "sub_text": "Permission to access User Management"
            },
            "account_management": {
              "title": "Account Management",
              "sub_text": "Permission to access Account Management"
            },
            "content_sources": {
              "title": "Content Sources",
              "sub_text": "Permission to access Content Sources"
            },

            "integrations": {
              "title": "Integrations",
              "sub_text": "Permission to access Integrations"
            },
            "custom_fields": {
              "title": "Custom Fields",
              "sub_text": "Permission to access CustomFields"
            },
            "email_templates": {
              "title": "Email Templates",
              "sub_text": "Permission to access Email Templates"
            },
            "notifications": {
              "title": "Notifications",
              "sub_text": "Permission to access Notifications"
            },
            "nda_templates": {
              "title": "NDA Templates",
              "sub_text": "Permission to access NDA Templates"
            },
            "privacy_policy_control": {
              "title": "Privacy Policy Control",
              "sub_text": "Permission to access Privacy Policy Control"
            }
          }
        }
      },
      "user_view": {
        "user_since": "User since",
        "user_role": "Choose user role",
        "select_role": "Select role",
        "search_users_placeholder": "Search users",
        "new_role": "Choose a user role",
        "starter_role": "Assign a starter seat to the user",
        "last_access": "Last access",
        "types": {
          "deactivated": "Deactivated",
          "active": "Active",
          "account_locked": "Account Locked"
        },
        "user_groups": {
          "title": "User groups",
          "sub_text": "Here's a list of user groups this user is a part of",
          "roles": {
            "admin": "Admin"
          },
          "actions": {
            "create_stream": "Create Stream",
          },
          "empty_message": {
            "title": "Shy cookie inside / No cookie in the jar!",
            "message": "Looks like this user isn’t a part of any user group yet. Maybe add them to one?"
          }
        },
        "actions": {
          "create_new_role": "Create New User Role",
          "deactivate_account": "Deactivate account",
          "activate_account": "Activate account",
          "deactivating_account": "Deactivating account",
          "activating_account": "Activating account",
        },
        "toast": {
          "update": "User account {status} successfully",
          "update_access": "User {field} access updated successfully",
          "resend_invitation_success": "User invitation re-sent successfully",
          "delete": "User invitation deleted successfully",
          "role": "User Role {activeUserRole} assigned successfully"
        }
      }
    },
    "viewer_settings": {
      "title": "Viewer Settings",
      "default_viewer": {
        "title": "Default Viewer",
        "sub_text": "Choose the default viewer your recipients will see when you share content.",
        "list_viewer": {
          "title": "List Viewer",
          "sub_text": "Arrange your assets in a vertical scrolling list."
        },
        "immerse_viewer": {
          "title": "Immerse Viewer",
          "sub_text": "Arrange your assets in a horizontal scrolling list."
        },
        "gallery_viewer": {
          "title": "Gallery Viewer",
          "sub_text": "Arrange your assets in a horizontal scrolling list."
        }
      },
      "customize_theme": {
        "title": "Customize Theme",
        "sub_text": "Design your themes in a way that's unique to your organisation. Customise colours and fonts to suit your brand's theme or for that matter, your moods.",
        "primary_color": "Primary Color",
        "button_text_color": "Button Text Color"
      },
      "library_settings": {
        "title": "Library Settings",
        "sub_text": "Customize how your library looks for external viewers. Library setting is standardised and will reflect the same for all your audience.",
        "change_logo": "Change <br/> company logo",
        "edit_background": "Edit Background",
        "header": "Header Text",
        "description": "Description Text",
        "button": "Button Text",
        "placeholder": "Placeholder Text",
        "share_collection": "Share Collection",
        "error_messages": {
          "reshare": "Oopsie... Our FLITE pilots cannot send a mail without a CTA."
        },
        "password_protected": {
          "title": "Password Protect Customization",
          "sub_text": "They Shall Not Pass! Without the password that is. Customise your password requirement text here.",
          "heading": "Please enter your password to continue viewing",
          "placeholder": "Enter password"
        },
        "gating_customization": {
          "title": "Gating Customization",
          "sub_text": "Customise how you would want to collect email from your anonymous users when you gate the collection.",
          "heading": "May we know who we are talking to, please?",
          "description_text": "We would like to know who is reading this please. All we need is an email.",
          "placeholder": "Please enter your email here",
          "button_text": "Continue",
        },
        "nda_customization": {
          "title": "NDA Customization",
          "sub_text": "Customise the look and feel of the NDA screen that's shown before the audience starts looking at the content.",
          "heading": "NDA Default Heading",
          "description": "We would like to know who is reading this please. All we need is an email.",
          "placeholder": "Please enter your email here"
        },
        "otp": {
          "title": "One-Time Password Customization",
          "sub_text": "Security two-fold! Customize your OTP message here.",
          "heading": "Verify OTP",
        },
        "email_content": {
          "title": "Email Content Customization",
          "sub_text": "Customize the content that goes into the body and footer of your email.",
          "email_content": "Email Content"
        }
      }
    },
    "hub_settings": {
      "title": "Hub Settings",
      "default_layout": "Default Layout",
      "edit": "Edit the layout and manage its access.",
      "actions": {
        "manage_layout": "Manage Layout",
        "delete_layout": "Delete Layout"
      },
      "empty_message": {
        "no_layouts": {
          "title": "No layouts found!",
          "sub_text": "There are no layouts associated with this account"
        },
        "no_group": {
          "title": "Where is everybody?",
          "sub_text": "There's no user group associated with this layout"
        }
      },
      "manage_layout": {
        "title": "manage layout",
        "sub_text": "Pull the strings to each layout and grant each different user groups the keys to their own layouts.",
        "user_groups_list": "List of user groups"
      },
      "delete_layout": {
        "title": "deleting",
        "sub_text": "Are you sure you'd like to permanently delete "
      }
    },
    "custom_fields": {
      "title": "Custom Fields",
      "add_custom_fields": "Add custom fields",
      "untitled": "Untitled",
      "create_custom_field": {
        "field_name": "Field name",
        "help_text": {
          "title": "Help text",
          "placeholder": "Enter help text"
        },
        "list_value": "List value",
        "allow_multi_select": "Allow multi select",
        "show_in_search": "Show in search page",
        "add_values": "Add values",
        "delete_tooltip": "Delete this option",
        "error_messages": {
          "valid_name": "Enter a valid name",
          "valid_options": "List values cannot be empty"
        },
        "actions": {
          "create_custom_field": "Create custom field",
          "update_custom_field": "Update custom field"
        }
      },
      "opportunity_field": "Opportunity field",
      "delete_tooltip": "Delete this field",
      "delete_option": "Delete this option",
      "delete_slider": {
        "title": "deleting",
        "sub_text": "Are you sure you would like to delete the selected custom field?",
        "toast": {
          "heading": "Success",
          "description": "Custom field {name} deleted successfully"
        }
      },
      "tooltip": {
        "delete": "Delete this field",
        "salesforce": "Salesforce opportunity field"
      }
    },
    "privacy_policy": {
      "title": "Privacy policy",
      "sub_text": "Links to privacy policy appear for your recipients when any content is shared. Please choose from Paperflite's standard privacy policy or set your own custom privacy policy.",
      "use": "Use",
      "paperflite_privacy_policy": "Paperflite privacy policy",
      "set_custom_policy": "Set custom privacy policy",
      "custom_policy_placeholder": "Url to privacy policy",
      "error_message": "Please provide a valid url",
      "consent_type": {
        "title": "Consent Type",
        "mandatory_content": {
          "title": "Mandatory consent",
          "sub_text": "The recipient has to accept the privacy policy and express consent that will be recorded. If not, they will not be able to view your content."
        },
        "optional_consent": {
          "title": "Optional consent",
          "sub_text": "The recipient has an option to accept the privacy policy. If they don't, their identity will not be recorded. Content engagement will still be tracked as anonymous users."
        },
        "no_consent": {
          "title": "No consent",
          "sub_text": "The recipient will not be requested for consent. This does not comply with GDPR."
        },
        "request_consent": "Request consent for recipients ONLY from the EU region. Turning this OFF will request consent from all recipients across the globe per settings above.",
        "save_policy_settings": "Save Policy Settings",
        "saving_policy_settings": "Saving Policy Settings",
      },
      "toast": {
        "heading": "Success",
        "description": "Privacy policy updated successfully"
      },
      "confirmation": {
        "sub_text": "Your privacy policy setting has changed. Would you like to request consent from all recipients including all of who may have already provided consent for the earlier version of the privacy policy?",
        "option": "request consent from all recipients",
        "bottom_text": "Please ignore this message and click confirm incase the changes have no legal impact"
      }
    },
    "payment_history": {
      "title": "Payment History",
      "sub_text": "View and manage your invoices and payments.",
      "invoice_date": "Invoice created on",
      "invoice_status": "Status",
      "invoice_download": "Download Invoice",
      "download": "DOWNLOAD All",
      "empty_message": {
        "title": "No invoice found!",
        "message": "There are no invoices available at the moment."

      }
    }
  },
  "stream_access_management": {
    "title": "List of private streams",
    "admin": "Admin",
    "sub_text": "Access to this stream can be configured at user level for additional security",
  },
  "distribution_lists": {
    "title": "Distribution List",
    "actions": {
      "create_new_list": "Create new list",
      "add_contacts": "Add contacts",
      "edit": "Edit",
      "delete": "Delete"
    },
    "search_placeholder": "Type here to search distribution list",
    "no_contact": "no contacts",
    "file_format_error": "Invalid file format. Please upload a CSV file in the required format.",
    "empty_message": {
      "title": "No visibility yet! This space is reserved for contacts",
      "distribution_list": {
        "title": "No cookie in the jar!",
        "message": "Create a Distribution List now by adding contacts to it. Send mails to multiple contacts using Distribution Lists.",
        "actions":{
          "create_now": "Create now"
        }
      }
    },
    "sliders": {
      "create_new_list": {
        "title": "new distribution list",
        "search_placeholder": "Enter a list name"
      },
      "add_contacts": {
        "title": "add contact",
        "sub_text": "to distribution list",
        "view_global_contacts": "VIEW GLOBAL CONTACTS",
        "placeholder": {
          "search": "Search contacts",
          "name": "Provide list name"
        },
        "actions": {
          "create_new_contact": "Create new contact",
          "upload_csv": "Upload CSV",
          "add_contact": "add contact",
          "update_contact": "Update contact"
        },
        "empty_message": {
          "title": "No search results?",
          "sub_text": "Add to your contact list to start tracking engagement and enhancing your conversations.",
          "name": "Enter a valid name"
        },
        "upload_csv": {
          "title": "Upload CSV",
          "sub_text": "Choose your CSV file with multiple contacts",
          "description": "Download CSV format template for uploading multiple contacts. Please Open the file in a spreadsheet program like Microsoft Excel or Google Sheets, Add your contacts and info in the format indicated, Save and Upload",
          "download_action": "Download sample template",
          "upload_contacts": "Upload Contacts",
          "note": "Psst! You can only have 100 contacts in your Distribution List at a time.",
          "progress": "Importing {0} of {1} contacts",
          "no_contacts": "No contacts here. Start building your empire. "
        },
        "delete_slider": {
          "title": "deleting",
          "description": "Are you sure you would like to delete the selected contact list?",
          "contact_list": "Contact List"
        }
      }
    }
  },
  "content_sources": {
    "title": "Connect to a new content source",
    "connected_sources": "Connected sources",
    "migrate": "Migrate",
    "migrating": "Migrating",
    "migrated_assets": "Migrated Assets",
    "existing_assets": "Existing Assets",
    "last_migrate_on": "Last migrated on",
    "processing_response": "Processing response",
    "empty_message":{
      "title": "Where is everybody?",
      "description": "No Content Source Connected"
    },
    "sliders": {
      "migrate": {
        "title": "migrate source",
        "heading": "This is a one time activity that will let you migrate all your content at once into Paperflite. There are three pointers to know before you proceed.",
        "description": {
          "note_one": "The activity is timebound completely based on the number of assets at the source.",
          "note_two": "This action is irreversible. Once you migrate the data, you cannot undo it.",
          "note_three": "Once you proceed with migration, all the assets from the datasource will be migrated at once to Paperflite and the corresponding mappings created from this datasource will be deleted."
        }
      },
      "delete": {
        "title": "delete source",
        "sub_text": "Are you sure you want to delete {name} source? {assetsCount} assets will be deleted, this step cannot be undone.",
      }
    },
    "rss_feed": {
      "title": "Rss Feed Url",
      "placeholder": "Enter your rss feed url",
      "error_message": "Url should point to xml file"
    },
    "toast": {
      "migrating": "Migrating {storageName} datasource {name}",
      "migration_success": "Migrated {storageName} datasource {name} successfully",
      "migrated_assets": "with {migratedAssets} migrated assets"
    },
    "reauthenticate": "Reauthenticate",
    "error_message": "Your authentication token to this content source has expired. Please re-authenticate to stay connected to your datasource.",
    "total_consumption": "TOTAL CONSUMPTION",
    "remaining_limit": "REMAINING LIMIT",
    "total_assets_uploaded": "TOTAL ASSETS UPLOADED",
    "remaining_asset_limit": "REMAINING ASSET LIMIT",
    "storage_limit": "Storage Limit"
  },
  "integrations": {},
  "templates": {
    "email": {
      "title": "Email Templates",
      "placeholder": {
        "template": "Search email templates",
        "detail": "Search email templates detail"
      },
      "create_new_template": "Create new template",
      "headers": {
        "template_name": "Template Name",
        "owner": "Owner",
        "last_updated": "Last Updated",
        "mark_as_public": "Mark as public",
      },
      "actions": {
        "create_new_template": "Create new template",
        "manage_content": "Manage content",
        "add_asset": "Add asset"
      },
      "empty_message": {
        "message": "Type less, Share more!",
        "action": {
          "create_new": "Create new"
        }
        },
      "loading_template": "Loading template",
      "default": "Default",
      "untitled": "Untitled",
      "uploadingMessage" : "Uploading",
      "errorMessage" : "The file format is not supported",
      "form":{
        "template_name": "Template Name",
        "template_placeholder": "Enter Template Name",
        "set_as_public": "Set as public",
        "set_as_default": "Set as default",
        "email_subject": "Email subject",
        "email_content": "Email content",
        "insert_placeholder": "Insert placeholder",
        "insert_widget_template": "Insert widget template",
        "valid_name": "Please provide a valid name",
        "valid_content": "Please provide a valid content"
      },
      "warning": {
        "deletion": {
          "title": "Invalid asset",
          "message": "Ouch. The asset(s) used in the template has been deleted. You can still use the rest of the template."
        },
        "internal": {
          "title": "Invalid asset",
          "message": "Ouch. The asset(s) used in the template has recently been marked only for internal use. You can still use the rest of the template."
        }
      },
      "sliders": {
        "title": "deleting",
        "sub_text": "Email Template",
        "description":"Are you sure you would like to delete the selected email template?"
      }
    },
    "nda":{
      "title": "NDA Templates",
      "create_nda": "Create NDA",
      "update_nda": "Update NDA",
      "delete_tooltip": "Delete this field",
      "actions": {
        "create_new_nda": "Create new NDA",
        "download_reports_success": "Downloaded all report successfully",
        "download_reports_failure": "Oops! Could not download the reports"

      },
      "form":{
        "template_name": "Template Name",
        "title": "Title",
        "nda_description": "NDA Description",
        "sub_text": "This text will appear to the end user to accept as terms",
        "error_message": "Please enter a valid name"
      },
      "sliders":{
        "title": "deleting",
        "sub_text": "NDA Signature",
        "description":"Are you sure you would like to delete the selected nda signature?",
        "toast": {
          "heading": "Success",
          "description": "NDA signature {name} deleted successfully"
        }
      }
    }
  },
  "more": {
    "about_paperflite": "About Paperflite",
    "privacy_policy": {
      "title": "Privacy Policy",
      
    },
    "terms_and_conditions": {
      "title": "Terms and Conditions",
    },
    "logout": "logout"
  },
  "toast": {
    "invite_success": "User {email} invited successfully",
    "delete_success": "User {email} deleted successfully",
    "fliteview_update": {
      "success": "Fliteview Settings updated successfully",
      "failure": "Unable to update Fliteview Settings"
    },
    "contacts_imported": {
      "success": "{count} Contacts imported successfully"
    },
    "no_acccess" : "You dont have permission to do this access"
  }
}